// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__X7T42","left":"layout_left__2nVbH","right":"layout_right__3j-Fa"};